import { Injectable, inject, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { Course } from '@lyceo/homi/shared/util-models';
import { CallState } from '@lyceo/shared/util-loading';
import * as CourseSelectors from './course.selectors';

@Injectable({
  providedIn: 'root',
})
export class CourseFacade {
  private readonly store: Store = inject(Store);

  public readonly allCourses: Signal<Course[]> = this.store.selectSignal(
    CourseSelectors.selectAllCourses,
  );

  public readonly getCoursesCallState: Signal<CallState> =
    this.store.selectSignal(CourseSelectors.selectGetCoursesCallState);

  public readonly coursesFinishedLoading: Signal<boolean> =
    this.store.selectSignal(CourseSelectors.selectCoursesFinishedLoading);
}
